import { createEndpoints } from './endpoints';
import { API_CONFIG } from '../config/api';
import { getTelegramInitData } from '../telegram/telegram';
import { store } from '../store/store';
import { uiActions } from '../store/slices/uiSlice';

export const endpoints = createEndpoints({
  baseUrl: API_CONFIG.BASE_URL,
  getInitData: getTelegramInitData,
  onForbidden: () => {
    const { isLoading } = store.getState().app;
    if (isLoading) return;

    store.dispatch(
      uiActions.setNotification({
        type: 'error',
        message: 'У вас нет прав для данной операции',
      }),
    );
  },
});
